import { createContext, ReactNode, useRef, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

import Alert from '../components/molecules/alert/Alert';

const AlertContext = createContext<(text: string) => void>((text: string) => {
  throw new Error('AlertContext must be used within the AlertProvider');
});

interface AlertProviderProps {
  children?: ReactNode;
}

export function AlertProvider({ children }: AlertProviderProps) {
  const [renderAlert, setRenderAlert] = useState<boolean>(false);
  const [text, setText] = useState<string>();
  const [key, setKey] = useState<string>(uuidv4());
  const timeout = useRef<NodeJS.Timeout>();

  function showAlert(text: string) {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    setKey(uuidv4());
    setText(text);
    setRenderAlert(true);
    timeout.current = setTimeout(() => {
      setRenderAlert(false);
      setText(undefined);
      timeout.current = undefined;
    }, 3000);
  }

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      {renderAlert && <Alert key={key} text={text} />}
    </AlertContext.Provider>
  );
}

export default AlertContext;
